const t = (str) => {
    return str;
    }
export default t;